import extractRawElm from './extract-raw-elm'

import { isHex, toHex } from './bits'

const BG_NONE = 'none'
const BG_EMPTY = ''
const BG_TRANSPARENT = 'transparent'
const BG_RGBA_TRANSPARENT = 'rgba(0, 0, 0, 0)'
const BG_RGBA_TRANSPARENT_RE = /rgba\(\d+,\s*\d+,\s*\d+,\s*0(\.[0-2]\d*)?\)/

export default function getBackgroundColor($elm) {
  const elm = extractRawElm($elm)
  const currBg = toHex(getCurrBg(elm))
  if (isHex(currBg)) {
    return currBg
  }

  const prntElm = elm.parentNode
  if (!prntElm || prntElm === document) {
    return '#ffffff'
  }

  return getBackgroundColor(prntElm)
}

function getCurrBg(elm) {
  const style = window.getComputedStyle(elm)
  const elmBg = style.backgroundColor
  const empty = false
    || !elmBg
    || elmBg === BG_EMPTY
    || elmBg === BG_NONE
    || elmBg === BG_TRANSPARENT
    || elmBg === BG_RGBA_TRANSPARENT
    || BG_RGBA_TRANSPARENT_RE.test(elmBg)

  return empty ? null : elmBg
}
